import { useIntl } from "react-intl";
import React from "react";
import { Checkbox, Input, Button, Tab, Header, Grid, Form, List, Modal, FormGroup, Segment } from "semantic-ui-react";
import ModInfo from "react-lib/apps/common/ModInfo";
import _ from "react-lib/compat/lodashplus";
const ToothEvaluationUX = (props: any) => {
  const intl = useIntl();
  const isMounted = React.useRef(true);

  React.useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div style={{ width: "100%", height: "100%", padding: "5px" }}>
      <div style={{ padding: "10px", display: "grid", gridTemplateColumns: "25% 25% 50%", gridTemplateRows: "repeat(6, 1fr)" }}>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>Shape</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Normal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "shape1", value: checked, text: label } })}
            checked={props.dentalExamData?.shape1?.value}
          ></Checkbox>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Abnormal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "shape2", value: checked, text: label } })}
            checked={props.dentalExamData?.shape2?.value}
          ></Checkbox>
          <Input
            value={props.dentalExamData?.shape3?.value}
            disabled={!props.dentalExamData?.shape2?.value}
            onChange={(e, { value }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "shape3", value: value, text: value, input: true } })}
          ></Input>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>{intl.formatMessage({ id: "cukey57" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Normal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "color1", value: checked, text: label } })}
            checked={props.dentalExamData?.color1?.value}
          ></Checkbox>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Abnormal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "color2", value: checked, text: label } })}
            checked={props.dentalExamData?.color2?.value}
          ></Checkbox>
          <Input
            value={props.dentalExamData?.color3?.value}
            disabled={!props.dentalExamData?.color2?.value}
            onChange={(e, { value }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "color3", value: value, text: value, input: true } })}
          ></Input>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>{intl.formatMessage({ id: "cukey204" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Normal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "texture1", value: checked, text: label } })}
            checked={props.dentalExamData?.texture1?.value}
          ></Checkbox>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Abnormal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "texture2", value: checked, text: label } })}
            checked={props.dentalExamData?.texture2?.value}
          ></Checkbox>
          <Input
            value={props.dentalExamData?.texture3?.value}
            disabled={!props.dentalExamData?.texture2?.value}
            onChange={(e, { value }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "texture3", value: value, text: value, input: true } })
            }
          ></Input>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>{intl.formatMessage({ id: "cukey167" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Normal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "position1", value: checked, text: label } })}
            checked={props.dentalExamData?.position1?.value}
          ></Checkbox>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Abnormal"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) => props.onEvent({ message: "SetCheckedDentalExam", params: { name: "position2", value: checked, text: label } })}
            checked={props.dentalExamData?.position2?.value}
          ></Checkbox>
          <Input
            value={props.dentalExamData?.position3?.value}
            disabled={!props.dentalExamData?.position2?.value}
            onChange={(e, { value }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "position3", value: value, text: value, input: true } })
            }
          ></Input>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>{intl.formatMessage({ id: "cukey36" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginLeft: "25px", marginRight: "10px" }}>{intl.formatMessage({ id: "cukey183" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Class I"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassRight1", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassRight1?.value}
          ></Checkbox>
          <Checkbox
            label="Class II"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassRight2", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassRight2?.value}
          ></Checkbox>
          <Checkbox
            label="Class III"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassRight3", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassRight3?.value}
          ></Checkbox>
          <Checkbox
            label="Unclassified"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassRight4", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassRight4?.value}
          ></Checkbox>
        </div>
        <div></div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginLeft: "25px", marginRight: "10px" }}>Left</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Checkbox
            label="Class I"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassLeft1", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassLeft1?.value}
          ></Checkbox>
          <Checkbox
            label="Class II"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassLeft2", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassLeft2?.value}
          ></Checkbox>
          <Checkbox
            label="Class III"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassLeft3", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassLeft3?.value}
          ></Checkbox>
          <Checkbox
            label="Unclassified"
            style={{ marginRight: "10px" }}
            onChange={(e, { checked, label }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "angleClassLeft4", value: checked, text: label } })
            }
            checked={props.dentalExamData?.angleClassLeft4?.value}
          ></Checkbox>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>{intl.formatMessage({ id: "cukey150" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Input
            type="number"
            value={props.dentalExamData?.overjet1?.value}
            onChange={(e, { value }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "overjet1", value: value, text: value, input: true } })
            }
          ></Input>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label>{intl.formatMessage({ id: "cukey233" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label style={{ marginRight: "10px", fontWeight: "bold" }}>{intl.formatMessage({ id: "cukey149" })}</label>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <Input
            type="number"
            value={props.dentalExamData?.overbit1?.value}
            onChange={(e, { value }) =>
              props.onEvent({ message: "SetCheckedDentalExam", params: { name: "overbit1", value: value, text: value, input: true } })
            }
          ></Input>
        </div>
        <div style={{ display: "flex", alignItems: "center", margin: "5px" }}>
          <label>{intl.formatMessage({ id: "cukey233" })}</label>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          position: "absolute",
          width: "100%",
          bottom: "40px",
        }}
      >
        {}
        <Button color="green" style={{ margin: "5px 0" }} onClick={props.handleSaveDentalExam}>
          {intl.formatMessage({ id: "cukey187" })}
        </Button>
      </div>
    </div>
  );
};

const DentalCariesRisk = (props: any) => {
  const intl = useIntl();
  const isMounted = React.useRef(true);

  React.useEffect(() => {
    return () => {
      isMounted.current = false;
    };
  }, []);

  return (
    <div style={{ width: "100%", height: "100%", padding: "5px" }}>
      <div style={{ textAlign: "center", paddingTop: "15px", paddingBottom: "15px" }}>
        <p style={{ lineHeight: "0" }}>
          <h2>{intl.formatMessage({ id: "cukey472" })}</h2>
        </p>
        {/* <p>
          <b>ภาควิชาทันตกรรมหัตถการ คณะทันตแพทยศาสตร์ จุฬาลงกรณ์มหาวิทยาลัยและแผนการจัดการ (สำหรับนิสิตระดับปริญญาบัณฑิต ดัดแปลงจากแบบประเมินของ ADA) </b>
        </p> */}
      </div>
      <Tab
        activeIndex={props.activeTabDentalCaries}
        onTabChange={(e: React.MouseEvent<HTMLDivElement, MouseEvent>, data: TabProp) => {
          if (data.activeIndex !== props.activeTabDentalCaries) {
            props.onEvent({ message: "SetActiveIndexDentalCaries", params: { index: data.activeIndex } });
          }
        }}
        panes={[
          {
            menuItem: "ส่วนที่ 1",
            render: () => (
              <Tab.Pane style={{ background: "rgb(253 254 175 / 20%)" }}>
                <div style={{ height: "478px" }}>
                  <Header as="h5" block style={{ background: "#fdfeaf", margin: "5px 0" }}>
                    {intl.formatMessage({ id: "cukey418" })}
                  </Header>

                  <Grid style={{ paddingLeft: "20px" }}>
                    <Grid.Row>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey13" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={4}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No1Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No1Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={4}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No1Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No1Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />{" "}
                              <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey24" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={3}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No4Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No4Choice1", value: checked, text: intl.formatMessage({ id: "cukey497" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey497" })}</label>
                            </Form.Field>
                            <Form.Field width={3}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No4Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No4Choice2", value: checked, text: intl.formatMessage({ id: "cukey484" }) },
                                  })
                                }
                              />{" "}
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey484" })}</label>
                            </Form.Field>
                            {/* <Form.Field width={4}>ระบุจำนวน</Form.Field>
                            <Form.Input
                              value={props.dentalCariesRisk?.sec1No4Choice3?.value}
                              width={4}
                              onChange={(e, { value }) =>
                                props.onEvent({
                                  message: "SetCheckedDentalCaries",
                                  params: { name: "sec1No4Choice3", value: value, input: true },
                                })
                              }
                            ></Form.Input>
                            <Form.Field width={3}>ต่อวัน</Form.Field> */}
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey18" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={4}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No2Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No2Choice1", value: checked, text: intl.formatMessage({ id: "cukey497" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey497" })}</label>
                            </Form.Field>
                            <Form.Field width={4}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No2Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No2Choice2", value: checked, text: intl.formatMessage({ id: "cukey484" }) },
                                  })
                                }
                              />{" "}
                              <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey484" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey27" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={3}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No5Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No5Choice1", value: checked, text: intl.formatMessage({ id: "cukey497" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey497" })}</label>
                            </Form.Field>
                            <Form.Field width={3}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No5Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No5Choice2", value: checked, text: intl.formatMessage({ id: "cukey484" }) },
                                  })
                                }
                              />{" "}
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey484" })}</label>
                            </Form.Field>
                            {/* <Form.Field width={3}>ระบุชื่อยา</Form.Field>
                            <Form.Field width={7}>
                              <Input
                                fluid
                                value={props.dentalCariesRisk?.sec1No5Choice3?.value}
                                onChange={(e, { value }) =>
                                  props.onEvent({ message: "SetCheckedDentalCaries", params: { name: "sec1No5Choice3", value: value, input: true } })
                                }
                              />
                            </Form.Field> */}
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey22" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={4}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No3Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No3Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={4}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No3Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No3Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />{" "}
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey28" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={3}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No6Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No6Choice1", value: checked, text: intl.formatMessage({ id: "cukey497" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey497" })}</label>
                            </Form.Field>
                            <Form.Field width={3}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec1No6Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec1No6Choice2", value: checked, text: intl.formatMessage({ id: "cukey484" }) },
                                  })
                                }
                              />
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey484" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </div>
              </Tab.Pane>
            ),
          },
          {
            menuItem: "ส่วนที่ 2",
            render: () => (
              <Tab.Pane style={{ background: "rgb(249 221 230 / 20%)" }}>
                <div style={{ height: "478px" }}>
                  <Header as="h5" block style={{ background: "#f9dde6", margin: "5px 0" }}>
                    {intl.formatMessage({ id: "cukey419" })}
                  </Header>
                  <div style={{ paddingLeft: "20px" }}>
                    <p>{intl.formatMessage({ id: "cukey15" })}</p>
                    <Form style={{ paddingLeft: "15px" }}>
                      <Form.Group inline>
                        <Form.Field width={3}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No1Choice1?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No1Choice1", value: checked, text: intl.formatMessage({ id: "cukey486" }) },
                              })
                            }
                          />
                          <label>{intl.formatMessage({ id: "cukey486" })}</label>
                        </Form.Field>
                        <Form.Field width={5}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No1Choice2?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No1Choice2", value: checked, text: intl.formatMessage({ id: "cukey11" }) },
                              })
                            }
                          />{" "}
                          <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey11" })}</label>
                        </Form.Field>
                        <Form.Field width={6}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No1Choice3?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No1Choice3", value: checked, text: intl.formatMessage({ id: "cukey352" }) },
                              })
                            }
                          />{" "}
                          <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey352" })}</label>
                        </Form.Field>
                      </Form.Group>
                    </Form>

                    <p>{intl.formatMessage({ id: "cukey19" })}</p>
                    <Form style={{ paddingLeft: "15px" }}>
                      <Form.Group inline>
                        <Form.Field width={3}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No2Choice1?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No2Choice1", value: checked, text: intl.formatMessage({ id: "cukey484" }) },
                              })
                            }
                          />
                          <label>{intl.formatMessage({ id: "cukey484" })}</label>
                        </Form.Field>
                        <Form.Field width={5}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No2Choice2?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No2Choice2", value: checked, text: intl.formatMessage({ id: "cukey497" }) },
                              })
                            }
                          />{" "}
                          <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey497" })}</label>
                        </Form.Field>
                      </Form.Group>
                    </Form>

                    <p>{intl.formatMessage({ id: "cukey20" })}</p>
                    <Form style={{ paddingLeft: "15px" }}>
                      <Form.Group inline>
                        <Form.Field width={3}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No3Choice1?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No3Choice1", value: checked, text: intl.formatMessage({ id: "cukey16" }) },
                              })
                            }
                          />
                          <label>{intl.formatMessage({ id: "cukey16" })}</label>
                        </Form.Field>
                        <Form.Field width={3}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No3Choice2?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No3Choice2", value: checked, text: intl.formatMessage({ id: "cukey10" }) },
                              })
                            }
                          />{" "}
                          <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey10" })}</label>
                        </Form.Field>
                        <Form.Field width={2}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No3Choice3?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({ message: "SetCheckedDentalCaries", params: { name: "sec2No3Choice3", value: checked, text: "0" } })
                            }
                          />{" "}
                          <label style={{ color: "red" }}>0</label>
                        </Form.Field>
                      </Form.Group>
                    </Form>

                    <p>{intl.formatMessage({ id: "cukey23" })}</p>
                    <Form style={{ paddingLeft: "15px" }}>
                      <Form.Group inline>
                        <Form.Field width={3}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No4Choice1?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No4Choice1", value: checked, text: intl.formatMessage({ id: "cukey484" }) },
                              })
                            }
                          />
                          <label>{intl.formatMessage({ id: "cukey484" })}</label>
                        </Form.Field>
                        <Form.Field width={3}>
                          <Checkbox
                            checked={props.dentalCariesRisk?.sec2No4Choice2?.value}
                            onChange={(e, { checked }) =>
                              props.onEvent({
                                message: "SetCheckedDentalCaries",
                                params: { name: "sec2No4Choice2", value: checked, text: intl.formatMessage({ id: "cukey497" }) },
                              })
                            }
                          />{" "}
                          <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey497" })}</label>
                        </Form.Field>
                      </Form.Group>
                    </Form>
                  </div>
                </div>
              </Tab.Pane>
            ),
          },
          {
            menuItem: "ส่วนที่ 3",
            render: () => (
              <Tab.Pane style={{ background: "rgb(205 241 217 / 20%)" }}>
                <div style={{ height: "478px" }}>
                  <Header as="h5" block style={{ background: "#cdf1d9", margin: "5px 0" }}>
                    {intl.formatMessage({ id: "cukey420" })}
                  </Header>
                  <Grid style={{ paddingLeft: "20px" }}>
                    <Grid.Row style={{ paddingBottom: "0" }}>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey12" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No1Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No1Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No1Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No1Choice2", value: checked, text: intl.formatMessage({ id: "cukey354" }) },
                                  })
                                }
                              />
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey354" })}</label>
                            </Form.Field>
                            {intl.locale !== "en" && (
                              <Form.Field width={5}>
                                <Checkbox
                                  checked={props.dentalCariesRisk?.sec3No1Choice3?.value}
                                  onChange={(e, { checked }) =>
                                    props.onEvent({
                                      message: "SetCheckedDentalCaries",
                                      params: { name: "sec3No1Choice3", value: checked, text: intl.formatMessage({ id: "cukey355" }) },
                                    })
                                  }
                                />{" "}
                                <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey355" })}</label>
                              </Form.Field>
                            )}
                          </Form.Group>
                          {intl.locale === "en" && (
                            <Form.Group inline>
                              <Form.Field width={15}>
                                <Checkbox
                                  checked={props.dentalCariesRisk?.sec3No1Choice3?.value}
                                  onChange={(e, { checked }) =>
                                    props.onEvent({
                                      message: "SetCheckedDentalCaries",
                                      params: { name: "sec3No1Choice3", value: checked, text: intl.formatMessage({ id: "cukey355" }) },
                                    })
                                  }
                                />{" "}
                                <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey355" })}</label>
                              </Form.Field>
                            </Form.Group>
                          )}
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey26" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No5Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No5Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No5Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No5Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row style={{ paddingBottom: "0" }}>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey17" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No2Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No2Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No2Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No2Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />
                              <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey29" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No6Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No6Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No6Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No6Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />{" "}
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row style={{ paddingBottom: "0" }}>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey21" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No3Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No3Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No3Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No3Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey30" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No7Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No7Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No7Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No7Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>

                    <Grid.Row style={{ paddingBottom: "0" }}>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey25" })}</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No4Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No4Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No4Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No4Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />
                              <label style={{ color: "#ec730a" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                      <Grid.Column width={8}>
                        <p>{intl.formatMessage({ id: "cukey31" })} </p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No8Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No8Choice1", value: checked, text: intl.formatMessage({ id: "cukey495" }) },
                                  })
                                }
                              />
                              <label>{intl.formatMessage({ id: "cukey495" })}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No8Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({
                                    message: "SetCheckedDentalCaries",
                                    params: { name: "sec3No8Choice2", value: checked, text: intl.formatMessage({ id: "cukey353" }) },
                                  })
                                }
                              />
                              <label style={{ color: "red" }}>{intl.formatMessage({ id: "cukey353" })}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row>
                    {/* <Grid.Row>
                      <Grid.Column width={8}></Grid.Column>
                      <Grid.Column width={8}>
                        <p>9. {intl.formatMessage({id: "cukey353"})}ภาวะน้ำลายแห้งรุนแรง เช่น ในผู้ป่วยที่ได้รับการฉายรังสีบริเวณใบหน้า</p>
                        <Form style={{ paddingLeft: "15px" }}>
                          <Form.Group inline>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No9Choice1?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({ message: "SetCheckedDentalCaries", params: { name: "sec3No9Choice1", value: checked, text: intl.formatMessage({id: "cukey495"}) } })
                                }
                              />
                              <label>{intl.formatMessage({id: "cukey495"})}</label>
                            </Form.Field>
                            <Form.Field width={5}>
                              <Checkbox
                                checked={props.dentalCariesRisk?.sec3No9Choice2?.value}
                                onChange={(e, { checked }) =>
                                  props.onEvent({ message: "SetCheckedDentalCaries", params: { name: "sec3No9Choice2", value: checked, text: intl.formatMessage({id: "cukey353"}) } })
                                }
                              />
                              <label style={{ color: "red" }}>{intl.formatMessage({id: "cukey353"})}</label>
                            </Form.Field>
                          </Form.Group>
                        </Form>
                      </Grid.Column>
                    </Grid.Row> */}
                  </Grid>
                </div>
              </Tab.Pane>
            ),
          },
        ]}
      />
      <div style={{ display: "flex", justifyContent: "flex-end" }}>
        {}
        <Button color="blue" style={{ margin: "5px 0" }} onClick={() => props.onEvent({ message: "SetNextSectionDentalCaries", params: {} })}>
          {intl.formatMessage({ id: "cukey311" })}
        </Button>
      </div>
    </div>
  );
};



const DentalExam = (props: any) => {
  const intl = useIntl();
  
  const panes = [
    {
      menuItem: "Tooth Evaluation",
      render: (props: any) => (
        <Tab.Pane style={{ height: "94%" }}>
          <ToothEvaluationUX {...props} />
        </Tab.Pane>
      ),
    },
    {
      menuItem: "Dental caries risk",
      render: (props: any) => (
        <Tab.Pane>
          <DentalCariesRisk {...props} />
          <ModInfo
            open={props.openModAssessment}
            type="warning"
            onApprove={() => props.setProp("openModAssessment", false)}
            onClose={() => props.setProp("openModAssessment", false)}
          >
            <div>{intl.formatMessage({ id: "cukey251" })}</div>
          </ModInfo>
          <Modal
            // onClose={() => props.setProp("openModalAssessmentResults", false)}
            open={props.openModalAssessmentResults}
            // closeIcon={true}
            style={{ top: "25%" }}
          >
            <div style={{ padding: "25px" }}>
              <div style={{ textAlign: "center", paddingTop: "15px", paddingBottom: "15px" }}>
                <p>
                  <b>{intl.formatMessage({ id: "cukey473" })} </b>
                </p>
                <p style={{ lineHeight: "0" }}>
                  <b>{intl.formatMessage({ id: "cukey350" })}</b>
                </p>
              </div>
  
              <div style={{ display: "flex", alignItems: "baseline", height: "11em", marginLeft: "40px" }}>
                <div style={{ width: "25%" }}>
                  <Header as="h2">{intl.formatMessage({ id: "cukey337" })}</Header>
                </div>
                <div style={{ paddingLeft: "5px", fontSize: "1.7em" }}>
                  {[
                    {
                      name: "ความเสี่ยงต่ำ",
                      color: "green",
                    },
                    {
                      name: "ความเสี่ยงกลาง",
                      color: "#ec730a",
                    },
                    {
                      name: "ความเสี่ยงสูง",
                      color: "red",
                    },
                  ].map((data, index) => (
                    <div style={{ display: "flex", alignItems: "center", margin: "15px" }}>
                      <div
                        style={{
                          width: "26px",
                          height: "26px",
                          border: "1px solid black",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          boxShadow: "0px 4px 4px #b4b2b2",
                        }}
                      >
                        <div
                          style={{
                            width: "16px",
                            height: "16px",
                            border: "1px solid black",
                            background: "black",
                            boxShadow: "0px 3px 3px #b4b2b2",
                            display: index === props.assessmentResults ? "" : "none",
                          }}
                        ></div>
                      </div>
                      <label style={{ marginLeft: "10px", color: data.color }}>{data.name}</label>
                    </div>
                  ))}
                </div>
              </div>
              <div
                style={{
                  borderRadius: "5px",
                  overflow: "hidden",
                  marginBottom: "10px",
                }}
              >
                {props.assessmentResults === 0 ? (
                  <>
                    <Segment inverted color="green" style={{ marginBottom: "-14px", border: "1px solid rgba(34,36,38,.5)", borderRadius: 0, borderBottom: 0 }}>
                      {intl.formatMessage({ id: "cukey115" })}
                    </Segment>
                    <Segment padded align="center" style={{ border: "1px solid rgba(34,36,38,.5)", borderRadius: 0 }}>
                      <div style={{ textAlign: "left" }}>
                        <List as="ul">
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <div>
                                <b>{intl.formatMessage({ id: "cukey178" })}</b>
                              </div>
                              <div style={{ paddingLeft: "5px" }}>
                                <div style={{ lineHeight: "1.7em" }}>patient every 6-9 months, consider increasing if remaining low risk.</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey130" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey129" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey201" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey136" })}</div>
                              </div>
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({ id: "cukey139" })}</b> pits and fissures with stain or early decay in
                              enamel, every decay in dentin.
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({ id: "cukey166" })}</b>or seal old restorations with poor margins, and
                              observe
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>Sealant</b>not required
                            </div>
                          </List.Item>
                        </List>
                      </div>
                    </Segment>
                  </>
                ) : props.assessmentResults === 1 ? (
                  <>
                    <Segment inverted color="orange" style={{ marginBottom: "-14px", border: "1px solid rgba(34,36,38,.5)", borderRadius: 0, borderBottom: 0 }}>
                      {intl.formatMessage({ id: "cukey120" })}
                    </Segment>
                    <Segment padded align="center" style={{ border: "1px solid rgba(34,36,38,.5)", borderRadius: 0 }}>
                      <div style={{ textAlign: "left" }}>
                        <List as="ul">
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <div>
                                <b>{intl.formatMessage({ id: "cukey178" })}</b>
                              </div>
                              <div style={{ paddingLeft: "5px" }}>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey239" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey81" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey244" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey136" })}</div>
                              </div>
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({ id: "cukey139" })}</b> stained pits, early decay in enamel (non-cavitation)
                              or optionally seal
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({ id: "cukey166" })}</b>or seal old restorations with fair margins, and
                              observe.
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>Sealant</b>deep pits & grooves
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({ id: "cukey182" })}</b>pits and fissures with early decay, old restorations
                              with poor margins.
                            </div>
                          </List.Item>
                        </List>
                      </div>
                    </Segment>
                  </>
                ) : props.assessmentResults === 2 ? (
                  <>
                    <Segment inverted color="red" style={{ marginBottom: "-14px", border: "1px solid rgba(34,36,38,.5)", borderRadius: 0, borderBottom: 0 }}>
                      {intl.formatMessage({ id: "cukey95" })}
                    </Segment>
                    <Segment padded align="center" style={{ border: "1px solid rgba(34,36,38,.5)", borderRadius: 0 }}>
                      <div style={{ textAlign: "left" }}>
                        <List as="ul">
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({ id: "cukey84" })}</b>with diary
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <div>
                                <b>{intl.formatMessage({id: "cukey178"})}</b> 
                                {intl.formatMessage({ id: "cukey238" })}
                              </div>
                              <div style={{ paddingLeft: "5px" }}>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey208" })} </div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey82" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey200" })}</div>
                                <div style={{ lineHeight: "1.7em" }}>{intl.formatMessage({ id: "cukey135" })}</div>
                              </div>
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b>{intl.formatMessage({ id: "cukey98" })}</b>
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({id: "cukey49"})}</b> 
                              {intl.formatMessage({ id: "cukey124" })}
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>Xylitol</b>-containing gum - 3 pieces daily
                            </div>
                          </List.Item>
                          <List.Item as="li">
                            <div style={{ display: "flex", alignItems: "baseline" }}>
                              <b style={{ marginRight: "5px" }}>{intl.formatMessage({id: "cukey74"})}</b> 
                              {intl.formatMessage({ id: "cukey232" })}
                            </div>
                          </List.Item>
                        </List>
                      </div>
                    </Segment>
                  </>
                ) : null}
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button color="green" style={{ margin: "5px 0" }} onClick={props.handleSaveAssessmentForm}>
                  {intl.formatMessage({ id: "cukey185" })}
                </Button>
              </div>
            </div>
          </Modal>
        </Tab.Pane>
      ),
    },
  ];

  return <Tab panes={panes} {...props} style={{ padding: "5px", height: "700px" }} />;
};

export default DentalExam;
